module.exports = __webpack_public_path__ + "static/media/heropic_better.5de0731f.jpg";